var Backbone = require('backbone'),
    SearchModel = require('./models/SearchModel'),
    SearchModelsCollection = require('./models/SearchModelsCollection'),
    SearchOptions = require('./models/SearchOptions'),
    FindAndRedactNoteModelConverter = require('./models/noteModelConverter'),
    fvChannel = require('glRadio').channel('FV');


/**
 * Note: searches are now assumed to have been 'searched' and will appear in results.
 * Those in the search forms have not yet been searched/added yet.
 * Exception: when provided via API, there is a small gap between searches being set
 * in the module constructor and the search being performed )
 * ** When provided by the API, more than one search can be provided; but otherwise we can only add one at a time **
 * Can only add/edit when searchPerformed is true.
 * When no search performed, there is a view with a model not in the searches.
 * This allows for providing multiple searches on entry ( but not manually -- which greatly complicated things ).
 */


module.exports = Backbone.Model.extend({

    defaults: {

        searches: new SearchModelsCollection(),  // collection facilitates Marionette Collection views

        searchPerformed: false,
        searchResults: null,

        userClickedHitId: null, // id of user clicked hit whose shapes we want to select on 'render' on the canvas ( note: now only one shape per hit )

        showResultsByPage: true, // if false, show them by search

        // // nWords X searchIndex: the indexes to search ( maybe later we have diff types )
        subsequentWordIndexCache: {} // Now a map of indexes ( of one kind ), separated by the number of words  // nWords X index: the indexes to search -- TODO: could be diff if have diff search options

    },

    /* now only called through results */
    addSearch: function( search ) {

        this.get('searches').add( search );

    },

    removeSearch: function( searchModel, fromEditOperaation ) {

        this.get('searches').remove( searchModel );

        /* Live Removal */
        if ( this.get('searchPerformed') ) {

            this.get('searchResults').removeSearch( searchModel );

            if ( !fromEditOperaation && this.get('searches').length < 1 ) {
                this.clearSearch();
            }

        }

    },

    /**
     *  Note:
     *  - topLevelSearchModel ( and it's title ) is set prior to the call.
     */
    doSearch: function( searchResults ) {

        // TODO: Need to clear existing???
        this.set({
            searchPerformed: true,
            searchResults: searchResults
        });

    },

    clearSearch: function( ) {

        this.get('searches').erase(); // I don't think need to destroy the individual ones

        if ( this.get('searchPerformed') ) {
            this.get('searchResults').destroy();
        }

        this.set({
            searches: new SearchModelsCollection(), // addSearch should be here
            searchPerformed: false,
            searchResults: null
        });


    },


    searchHasResults: function() {

        if ( !this.get('searchPerformed') )
            return false;

        var searchResults = this.get('searchResults');

        return searchResults && searchResults.hasResults();

    },

    /* Shouldn't need anymore if validated one at a time, unless when pass in */
    allSearchesAreValid: function() {

        return this.get('searches').every( function( sm ) {
            return sm.isValid();
        });

    },

    getNumberOfSearches: function() {

        return this.get('searches').length;
    },

    getSearchResultsTree: function() {

        if ( !this.get('searchPerformed') ) {
            return null;
        }

        return this.get('showResultsByPage')
            ? this.get('searchResults').getPageTree()
            : this.get('searchResults').getSearchTree();

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/state.js
 ** module id = 581
 ** module chunks = 0
 **/